import React from 'react';
import PageHeaderStyles from './PageHeader.styled';

const PageHeader = () => {
  return (
    <PageHeaderStyles>
      <h1 className="page-header label large">Studio</h1>
    </PageHeaderStyles>
  );
};

export default PageHeader;
